import React from "react"
import Animate, { AnimationTypes } from "../Animate/Animate"
import { ToggleValue } from "../../hooks/useToggle"
import { useTranslation } from "react-i18next"
import type { InteractionDescriptionProps } from "../InteractionTooltip/InteractionTooltip"

interface ToggleComponetProps extends InteractionDescriptionProps {
  canSelectType: boolean
  valuesToggle: string[]
  selectedType: ToggleValue[]
  disable?: boolean
  delay?: string
  animationTypes?: keyof typeof AnimationTypes
  animationDuration?: string
  handleToggleSelection: (isOnlySelection: boolean, data: string, onChange: (e: ToggleValue[]) => void) => void
  handleChangeType: (e: string[]) => void
}

export const ToggleComponet: React.FC<ToggleComponetProps> = ({
  valuesToggle,
  selectedType,
  handleToggleSelection,
  handleChangeType,
  canSelectType,
  delay = "0s",
  animationDuration = "1s",
  disable,
  animationTypes = AnimationTypes.fadeInTraslate,
  descriptionKey,
}) => {
  const { t } = useTranslation("interactionDescriptions")

  if (!canSelectType) return null

  return (
    <Animate type={animationTypes} duration={animationDuration} delay={delay}>
      <div
        className="
          flex flex-wrap gap-2
          p-1
          rounded-xl
          bg-slate-100
          border-2 border-slate-200
        "
      >
        {valuesToggle.map((ss) => {
          const isSelected = selectedType.includes(ss)

          return (
            <button
              data-interaction-description-key={descriptionKey}
              aria-label={`${t(descriptionKey)} ${ss}`}
              key={ss}
              type="button"
              disabled={disable}
              onClick={() => handleToggleSelection(true, ss, handleChangeType)}
              className={`
                px-4 py-1.5
                rounded-lg
                text-xs md:text-sm
                font-semibold
                transition-all duration-300
                ${
                  isSelected
                    ? "bg-gradient-to-r from-orange-300 to-orange-200 text-black shadow-md ring-2 ring-orange-500"
                    : "bg-white text-gray-700 hover:bg-slate-200"
                }
                ${disable ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
              `}
            >
              {ss}
            </button>
          )
        })}
      </div>
    </Animate>
  )
}
